// Describes the arrow style of polylines
export const ArrowStyles = {
  NONE: 0,
  FORWARD: 1,
  BACKWARD: 2,
  BOTH: 3,
};

export const DEFAULT_ARROWS = 1;
export const MAX_ARROWS = 3;
